import React from 'react';
import { Flex } from 'antd-mobile';

import styles from './index.modules.less';

const CornerMarker = ({ cornerMarkerRespDto: v, style = {}, textStyle = {} }) => {
  if (!v) return null;
  const { status, weighColor, backgroundColor, name } = v || {};
  if (status != 1) return null;
  return (
    <Flex
      align="center"
      justify="center"
      style={{
        backgroundColor,
        ...style
      }}
      className={styles.cornerMarker}>
      <span
        className={styles.textContent}
        style={{
          color: weighColor,
          ...textStyle
        }}>
        {name}
      </span>
    </Flex>
  );
};

export default CornerMarker;



// WEBPACK FOOTER //
// ./src/components/CornerMarker/index.jsx